var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.96484 11.0002V12.8C1.96484 13.9201 1.96484 14.4798 2.18283 14.9076C2.37458 15.2839 2.68032 15.5905 3.05664 15.7822C3.48405 16 4.04384 16 5.16175 16H19.965M1.96484 11.0002V1M1.96484 11.0002L5.81824 7.78906L5.82143 7.78651C6.51851 7.20561 6.86772 6.91459 7.24639 6.79639C7.69371 6.65675 8.17555 6.67884 8.6084 6.8584C8.97534 7.01062 9.2971 7.33238 9.94061 7.97589L9.94706 7.98234C10.6006 8.63584 10.9282 8.96346 11.301 9.11535C11.7422 9.29508 12.2334 9.31056 12.6855 9.16057C13.0689 9.0334 13.419 8.72755 14.1191 8.11496L19.9648 3",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.95df3646f24f0a396960e520b5a9f55f.svg";
export { ForwardRef as ReactComponent };